/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContentRef } from './ContentRef';
import {
    ContentRefFromJSON,
    ContentRefFromJSONTyped,
    ContentRefToJSON,
    ContentRefToJSONTyped,
} from './ContentRef';

/**
 * Result of content write; contains ref and size, no payload
 * @export
 * @interface ContentWriteResult
 */
export interface ContentWriteResult {
    /**
     * Whether the write succeeded
     * @type {boolean}
     * @memberof ContentWriteResult
     */
    success?: boolean;
    /**
     * Opaque reference to stored content
     * @type {ContentRef}
     * @memberof ContentWriteResult
     */
    contentRef?: ContentRef;
    /**
     * Size of written content in bytes
     * @type {number}
     * @memberof ContentWriteResult
     */
    sizeBytes?: number;
    /**
     * Error message if success is false
     * @type {string}
     * @memberof ContentWriteResult
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the ContentWriteResult interface.
 */
export function instanceOfContentWriteResult(value: object): value is ContentWriteResult {
    return true;
}

export function ContentWriteResultFromJSON(json: any): ContentWriteResult {
    return ContentWriteResultFromJSONTyped(json, false);
}

export function ContentWriteResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentWriteResult {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'contentRef': json['contentRef'] == null ? undefined : ContentRefFromJSON(json['contentRef']),
        'sizeBytes': json['sizeBytes'] == null ? undefined : json['sizeBytes'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function ContentWriteResultToJSON(json: any): ContentWriteResult {
    return ContentWriteResultToJSONTyped(json, false);
}

export function ContentWriteResultToJSONTyped(value?: ContentWriteResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'contentRef': ContentRefToJSON(value['contentRef']),
        'sizeBytes': value['sizeBytes'],
        'errorMessage': value['errorMessage'],
    };
}

